import React from 'react';

import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import TabsContent, { TabsGroup } from '../../components/tabsContent';

interface TabsContentSectionProps extends Section {
  tabsgroup: TabsGroup;
}

const TabsContentSection: SectionComponent<TabsContentSectionProps> = React.memo(
  ({ tabsgroup }) => (
    <>
      <TabsContent tabsgroup={tabsgroup}></TabsContent>
    </>
  ),
);

export default TabsContentSection;
